import { apiGet, apiPut } from './client';

export interface CustomerFeaturesResponse {
  customerId: string;
  features: Record<string, boolean>;
}

/** Portal feature keys (mirror of server-side PORTAL_FEATURES). */
export const PORTAL_FEATURE = {
  EMAIL_FORWARDING: 'email_forwarding',
} as const;

export function getCustomerFeatures(customerId: string): Promise<CustomerFeaturesResponse> {
  return apiGet<CustomerFeaturesResponse>(`/api/admin/customers/${customerId}/features`);
}

export function setCustomerFeature(
  customerId: string,
  feature: string,
  enabled: boolean
): Promise<{ customerId: string; feature: string; enabled: boolean }> {
  return apiPut(`/api/admin/customers/${customerId}/features/${feature}`, { enabled });
}
